import styled from 'styled-components';
import { BaseDivHomePage } from '../styles';

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  background: ${({ theme }) => theme.pantone657C};
  padding: 3rem 0;
`;

export const AreaCollumnsFooter = styled(BaseDivHomePage)`
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
  justify-content: space-between;
  align-items: flex-start;
  gap: 2rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    grid-template-columns: 1fr;
    align-items: center;
  }
`;
export const AreaIconLogo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;

  svg {
    color: ${({ theme }) => theme.white};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
`;

export const AreaDemo = styled.div``;

export const AreaAllRights = styled(BaseDivHomePage)``;

export const HorizontalLine = styled.hr`
  width: 100%;
  border: 0;
  border-top: 1px solid ${({ theme }) => theme.white};
`;
export const Logo = styled.img`
  width: 100%;
  max-width: 120px;
`;

export const AreaSubPages = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-around;
  gap: 2rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    justify-content: space-between;
  }
`;

export const WrapperSubPages = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`;

export const TitleSubPages = styled.h3`
  color: #94a3b8;
  font-size: 1.2rem;
  text-transform: uppercase;
`;

export const LinkSubPage = styled.span`
  color: ${({ theme }) => theme.white};
  font-size: 0.9rem;

  :hover {
    filter: brightness(0.5);
  }
`;

